// index.js
import Vue from "vue";
import VueRouter from "vue-router";
import dashboardRoute from "./modules/dashboard";
import citizensRoute from "./modules/citizens";
import managementRoute from "./modules/management";
import { checkLoggedIn } from "./modules/auth-guard";
import { triggerAlert, resetAlertValues } from "./modules/alerts";
import publicRoutes from "./modules/public-routes";
// import html2pdfPage from "../components/File Viewer/FileViewer.vue"
import hospitalServicesRoute from "./modules/hospital-services";
import doctorRoute from "./modules/doctor";
import dialysisRoute from "./modules/dialysis";
import EnumsRoute from "./modules/enums";
import diagnosticsRoute from "./modules/diagnostics";
import laboratoriesRoute from "./modules/laboratories";
import generalServices from "./modules/general-services";
import footerRoute from "./modules/footer";

// Store
import store from "@/store";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    redirect: { name: "login" },
  },
  {
    path: "/login",
    name: "login",
    component: () =>
      import(/* webpackChunkName: "login" */ "@/views/LandingPageView.vue"),
    meta: {
      routeName: "Login",
    },
  },
  ...dashboardRoute,
  ...citizensRoute,
  ...managementRoute,
  ...publicRoutes,
  ...hospitalServicesRoute,
  ...doctorRoute,
  ...dialysisRoute,
  ...EnumsRoute,
  ...diagnosticsRoute,
  ...laboratoriesRoute,
  ...generalServices,
  ...footerRoute,
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  },
});

// Use the checkLoggedIn global navigation guard
router.beforeEach(checkLoggedIn);

// Check if the route changes and must delete the sessionStorage on reroute.js
router.beforeEach((to, from, next) => {
  const includedPublicRoutes = [
    ...publicRoutes
      .filter(({ name }) => name !== "Minalin Dialysis Center")
      .map(({ name }) => name),
  ];

  if (!includedPublicRoutes.includes(to.name)) {
    sessionStorage.removeItem("hub_registrant_id");
  }

  // Reset alert properties initiated by triggerAlert
  resetAlertValues(from);

  // Reset various states upon route change
  if (store.state.alerts.alertTimeout) {
    store.dispatch("alerts/resetLoading");
  }

  next();
});

// Constantly update the HTML title per route change
router.afterEach((to, from) => {
  Vue.nextTick(() => {
    document.title = `${to.meta.routeName} | CHIMS`;
  });

  // Tiggers alert when it cannot be done through store
  triggerAlert(from);
});

export default router;
